// extracted by mini-css-extract-plugin
module.exports = {"item":"link-module--item--2qyFR","link":"link-module--link--1GQbK"};